// extracted by mini-css-extract-plugin
export default {"spin":"spinner_spin__T-ntE","spinner":"spinner_spinner__ceNjm","container":"spinner_container__wBxdy"};